import http from "./http-common";

class PatientService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) =>
        key &&
        payload[key] !== undefined &&
        payload[key] !== null &&
        payload[key] !== ""
          ? key + "=" + payload[key]
          : ""
      )
      .filter(Boolean)
      .join("&");
  }

  /* to register a new patient */
  PatientRegistration(payload) {
    return http.post("/patient/", payload);
  }

  /* this api is used to get the list of all the patient*/
  PatientList(payload) {
    return http.get(`/patient/list/filter?${payload}`);
  }
  PatientListRPM(payload) {
    const queryString = new URLSearchParams(payload).toString();
    return http.get(`/patient/list/filter?${queryString}`);
  }
  PatientCount(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patient/patientCountStatus?${queryString}`);
  }
  PatientQrData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`patient/consultation/list/filter?${queryString}`);
  }
  /* this api is used to filters the patient*/
  PatientListFilter(payload) {
    const queryString = Object.entries(payload)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return http.get(`/patient/list/filter?${queryString}`);
  }

  EditPatient(data) {
    return http.put(`/patient/${data.id}`, data);
  }

  isPermissionGranted(data) {
    const queryString = this.queryString(data);
    return http.get(`/patientHistoryAccess/list/filter?${queryString}`);
  }
  patientQueueList(data) {
    const queryString = this.queryString(data);
    return http.get(`/patientAppointment/get/queue/status?${queryString}`);
  }
  patientPaymentDetails(data) {
    return http.get(`/shareLinkTransaction/list/filter?transactionId=${data}`);
  }
  getMyReport(payload) {
    var queryString = Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
    return http.get(`patientDocument/list/filter?${queryString}`);
  }
  EditPatientData(payload) {
    return http.put(`/patient/${payload.id}`, payload);
  }
  AddPatient(payload) {
    return http.post("/patient/", payload);
  }

  patientWatchData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/webhooks/garmin/list?offset=0&${queryString}`);
  }

  GetGarminDevices(payload) {
    return http.get("/webhooks/garmin/list", {
      params: payload,
    });
  }
  DayStepDetails(payload) {
    return http.get("/webhooks/garmin/dayStepDetails", {
      params: payload,
    });
  }

  GarminRespirationDailyData(payload) {
    var queryString = this.queryString(payload);
    return http.get(`webhooks/garmin/dayWiseList?${queryString}`);
  }

  GarminRespirationWeeklyData(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/webhooks/garmin/weeklyWiseList?${queryString}`);
  }
}

export default new PatientService();
